import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import VideoUpload from "components/shared/VideoUpload";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const MediaSection = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [videoType, setVideoType] = useState("link");
  const [selectedVideo, setSelectedVideo] = useState({
    preview: null,
    path: "",
  });

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(getSection({ page: "home", slug: "mediaSection" }));
  }, [dispatch]);

  useEffect(() => {
    reset(section);
    setVideoType(section?.videoType || "link");
    setSelectedVideo({ preview: null, path: section?.video || "" });
  }, [reset, section]);

  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    data.videoType = videoType;

    if (videoType === "upload") {
      if (!selectedVideo?.path) {
        toastErrorMessage(
          formatMessage({ id: "videoErrorMessage" }),
          locale
        );
        return;
      }
      data.video = `/uploads/${selectedVideo?.path?.split("/").pop()}`;
    } else {
      data.video = data.videoUrl;
    }

    delete data.videoUrl;

    dispatch(
      editSection({
        slug: "mediaSection",
        page: "home",
        data: { section: data },
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-head">
          <h4>
            <FormattedMessage id="mediaSection" />
          </h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Col xl={8} md={12}>
              {/* title */}
              <Row>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="heading.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="heading.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>

              {/* description */}
              <Row>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="description"
                    name="description.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="description"
                    name="description.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>

              {/* video type toggle */}
              <div className="form-group">
                <h5>
                  <FormattedMessage id="videoSource" />
                </h5>
                <div className="d-flex gap-3 mb-3">
                  <label className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="videoType"
                      value="link"
                      checked={videoType === "link"}
                      onChange={() => setVideoType("link")}
                    />
                    <FormattedMessage id="videoLink" />
                  </label>
                  <label className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="videoType"
                      value="upload"
                      checked={videoType === "upload"}
                      onChange={() => setVideoType("upload")}
                    />
                    <FormattedMessage id="uploadVideo" />
                  </label>
                </div>

                {videoType === "link" ? (
                  <Row>
                    <Col lg={6} xs={12}>
                      <Input
                        langId="videoLink"
                        name="videoUrl"
                        register={register}
                        errors={errors}
                        defaultValue={section?.video}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Col lg={12} xs={12}>
                    <VideoUpload
                      selectedVideo={selectedVideo}
                      setSelectedVideo={setSelectedVideo}
                    />
                  </Col>
                )}
              </div>

              <SaveChangesButton />
            </Col>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MediaSection;
